<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { InputCheckboxTrueFalse } from '@/components/inputs';
import InputTextbox from './InputTextbox.vue';

const props = defineProps({
  modelValue: {
    type: [String, Boolean],
    default: false,
  },
  optionTrue: {
    type: String,
    required: true,
  },
  optionFalse: {
    type: String,
    required: true,
  },
  mainColor: {
    type: String,
    required: true,
  },
  backgroundColor: {
    type: String,
    required: true,
  },
  textFont: {
    type: String,
    default: 'null',
  },
  placeholder: {
    type: String,
    default: '',
  },
  fancy: {
    type: Boolean,
    default: false,
  },
  borderRadius: {
    type: String,
    default: '20px',
  },
});

const emits = defineEmits(['update:modelValue']);

function setCheckboxVal() {
  if (props.modelValue && props.modelValue !== '') {
    return true;
  }

  return false;
}

const checkboxVal = ref(setCheckboxVal());

const model = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emits('update:modelValue', val);
  },
});

watch(checkboxVal, (val) => {
  if (val === false) {
    emits('update:modelValue', false);
  } else {
    emits('update:modelValue', '');
  }
});

onMounted(() => {
  if (!checkboxVal.value) {
    model.value = false;
  }
});
</script>

<template>
  <div class="input">
    <p v-if="$slots.default" class="custom-font">
      <slot></slot>
    </p>

    <InputCheckboxTrueFalse
      v-model="checkboxVal"
      :option-true="optionTrue"
      :option-false="optionFalse"
      :main-color="mainColor"
      :background-color="backgroundColor"
      :text-font="textFont"
      :fancy="fancy"
    />
    <transition name="fade" mode="out-in">
      <div v-if="checkboxVal" class="textbox">
        <InputTextbox
          v-model="model"
          :placeholder="placeholder"
          :main-color="mainColor"
          :background-color="backgroundColor"
          :text-font="textFont"
          :border-radius="borderRadius"
        >
          <p class="label">Podaj imię i nazwisko osoby towarzyszącej:</p>
        </InputTextbox>
      </div>
    </transition>
  </div>
</template>

<style lang="scss">
/* stylelint-disable selector-class-pattern */
.rsvp-guest-checkbox-true-false > .q-checkbox__inner,
.rsvp-guest-checkbox-true-false > .q-checkbox__inner--truthy {
  color: v-bind(mainColor) !important;
}
/* stylelint-enable selector-class-pattern */
</style>

<style lang="scss" scoped>
@import '@/assets/styleConstans';

.input {
  border: none;
  align-items: center;
  justify-content: center;
  background-color: v-bind(backgroundColor);
  width: 100%;
  margin: auto;
}

.label {
  font-family: v-bind(textFont), 'Petit Formal Script', serif;
  text-align: center;
  font-size: 1.6em;

  @media screen and (max-width: $media-phone) {
    font-size: 1.25em;
  }
}

.textbox {
  width: 100%;
}

.custom-font {
  font-family: v-bind(textFont), 'Petit Formal Script', serif;
}
</style>
